<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Double Espresso</h1>
</div>
</div>
<h4 style="text-align: center;">
	A Loretto Kovacs Novel</h4>
<h3>
<br/>
	Anthony Bruno</h3>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?21b0bbfb